import { Link } from "react-router-dom";
import BasicLoginConfigForm from "./BasicLoginConfigForm";
import { CREATE_BASIC_LOGIN_CONFIG } from "./query";

const CreateBasicLoginConfig = () => {
    return (
        <div className="custom-shadow p-5">
            <Link to="/global-config/basic-login" className="btn btn-outline-primary">
                Back
            </Link>

            <h3 className="mb-5 mt-4">Create Basic Login Configuration</h3>

            <BasicLoginConfigForm query={CREATE_BASIC_LOGIN_CONFIG} />
        </div>
    );
};

export default CreateBasicLoginConfig;
